// SplitPie.jsx — a pie split card in the same style as the Summary page's Overview.

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import PropTypes from 'prop-types';

import { recruitmentCss as css } from '@digital_monorepo/styling';

ChartJS.register(ArcElement, Tooltip, Legend);

const pieOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'right', labels: { boxWidth: 12, padding: 12 } },
    tooltip: {
      callbacks: {
        label: ctx => {
          const total = ctx.dataset.data.reduce((sum, n) => sum + n, 0);
          const pct = total ? Math.round((ctx.parsed / total) * 100) : 0;
          return ` ${ctx.label}: ${ctx.parsed} (${pct}%)`;
        }
      }
    }
  }
};

const SplitPie = ({ title, items, colours }) => (
  <div className={css.chartCard}>
    <h3 className={css.chartCardTitle}>{title}</h3>
    {items.length ? (
      <div className={css.chartCanvas}>
        <Pie
          aria-label={`${title}: ${items.map(i => `${i.label} ${i.count}`).join(', ')}`}
          role='img'
          data={{
            labels: items.map(i => i.label),
            datasets: [{ data: items.map(i => i.count), backgroundColor: items.map((i, n) => colours(i.label, n)), borderColor: '#fff', borderWidth: 2 }]
          }}
          options={pieOptions}
        />
      </div>
    ) : (
      <p className={css.emptyNote}>No candidates</p>
    )}
  </div>
);

SplitPie.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, count: PropTypes.number })).isRequired,
  colours: PropTypes.func.isRequired
};

export default SplitPie;
